import { readNeonUrls, resolveBackend } from '../neon/config'

export type AppEnvironment = 'development' | 'production'

/**
 * Connection settings of the configured backend. The name is historical: with VITE_BACKEND=neon (off by default) `url` is the Neon Data API
 * address, `publishableKey` is empty and `authUrl` is the auth Worker. `url` is what identifies the "project" of the local workspace.
 */
export interface SupabaseConfig {
  url: string
  publishableKey: string
  environment: AppEnvironment
  isDev: boolean
  backend?: 'supabase' | 'neon'
  authUrl?: string
}

export function resolveAppEnvironment(value: unknown): AppEnvironment {
  if (value === 'production') return 'production'
  return 'development'
}

function configuredEnvironment(): AppEnvironment {
  return resolveAppEnvironment(import.meta.env.VITE_APP_ENV)
}

export function getSupabaseConfig(): SupabaseConfig | null {
  if (resolveBackend(import.meta.env.VITE_BACKEND) === 'neon') {
    const urls = readNeonUrls(import.meta.env)
    if (!urls) return null
    const environment = configuredEnvironment()
    return { url: urls.dataApiUrl, publishableKey: '', environment, isDev: environment === 'development', backend: 'neon', authUrl: urls.authUrl }
  }
  const url = import.meta.env.VITE_SUPABASE_URL?.trim()
  const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim()
  if (!url || !publishableKey) return null

  const environment = configuredEnvironment()
  return {
    url,
    publishableKey,
    environment,
    isDev: environment === 'development',
  }
}
